import React from 'react';
import '../App.css';

export default function ContactForm() {
  return (
    <section className="page-hero page-hero-contact">
      <div className="container">
        <h1>Contact Us</h1>
        <div className="contact-frame">
          <iframe title="Contact Gridspot" src="https://docs.google.com/forms/d/e/1FAIpQLSdrRGpfetiP-T141gGuFfW7q26JrpRKB1eSneUk7iFUk-a-Pg/viewform?embedded=true">Loading…</iframe>
        </div>
      </div>
    </section>
  )
}
